import {LangKeyType} from '../../../../provider/locale/translation/type';
import {VideoSkipReasonEnum} from '../../../../service/company/company-type';

export const VISIBLE_SKIPPED_COMPANIES_COUNT = 3;

/**
 * CCL_NOT_SYNCED is the backend's own catch-all, so anything unknown lands there. Done here rather than in the
 * zod schema: when the response fails validation deserializeV2 hands back the raw payload, and a company with an
 * unmapped reason would then fall out of every group and leave the alert empty.
 */
export function getVideoSkipReason(reason: unknown): VideoSkipReasonEnum {
    return Object.values<unknown>(VideoSkipReasonEnum).includes(reason)
        ? (reason as VideoSkipReasonEnum)
        : VideoSkipReasonEnum.CclNotSynced;
}

/** Groups follow the backend check order, so the alert reads the same way the reasons are resolved. */
export const VIDEO_SKIP_REASONS_ORDER: Array<VideoSkipReasonEnum> = [
    VideoSkipReasonEnum.NoLicence,
    VideoSkipReasonEnum.PushDisabled,
    VideoSkipReasonEnum.CclNotSynced,
];

/**
 * `all` and `part` talk about "the selected companies"; `single` is for exactly one company (the company card, or a
 * bulk selection of one). The `__ALL` texts of NO_LICENCE and CCL_NOT_SYNCED name no selection, so `single` reuses them.
 */
export const VIDEO_SKIP_REASON_MESSAGE: Record<
    VideoSkipReasonEnum,
    {all: LangKeyType; part: LangKeyType; single: LangKeyType}
> = {
    [VideoSkipReasonEnum.NoLicence]: {
        all: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__NO_LICENCE__ALL',
        part: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__NO_LICENCE__PART',
        single: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__NO_LICENCE__ALL',
    },
    [VideoSkipReasonEnum.PushDisabled]: {
        all: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__PUSH_DISABLED__ALL',
        part: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__PUSH_DISABLED__PART',
        single: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__PUSH_DISABLED__SINGLE',
    },
    [VideoSkipReasonEnum.CclNotSynced]: {
        all: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__CCL_NOT_SYNCED__ALL',
        part: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__CCL_NOT_SYNCED__PART',
        single: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__CCL_NOT_SYNCED__ALL',
    },
};

export const VIDEO_SKIP_REASON_GROUP_TITLE: Record<VideoSkipReasonEnum, LangKeyType> = {
    [VideoSkipReasonEnum.NoLicence]: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__NO_LICENCE__GROUP_TITLE',
    [VideoSkipReasonEnum.PushDisabled]: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__PUSH_DISABLED__GROUP_TITLE',
    [VideoSkipReasonEnum.CclNotSynced]: 'BULK_EDIT_COMPANIES__VIDEO_SKIPPED__CCL_NOT_SYNCED__GROUP_TITLE',
};
